import { ImgIfExists } from "@components/ImgIfExists";
import { useBankLogo } from "@contexts/ClientSettings/BankLogo";
import { Divider } from "antd";

export const BankLogo = () => {
  const { url } = useBankLogo();

  return (
    <>
      {url && <Divider type="vertical" className="mx-6 h-8" />}
      <ImgIfExists
        alt="Logo do banco"
        className="max-h-full max-w-full"
        src={url}
      />
    </>
  );
};
